import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetReferralSectionResult } from './get-referral-section.result';

export async function getReferralSection(): Promise<GetReferralSectionResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetReferralSectionResult[]>(`/firms/referral-section-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
